import { render, staticRenderFns } from "./BankTransfersAuto.vue?vue&type=template&id=96eb9158&"
import script from "./BankTransfersAuto.vue?vue&type=script&lang=js&"
export * from "./BankTransfersAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports